/**
 * iOS only raises the keyboard for a focus() made inside the tap itself, and
 * the dialog focuses its input a frame later. Focusing a throwaway field in
 * the tap opens the keyboard, which then stays up when focus moves on.
 */
export const primeMobileKeyboard = () => {
  const field = document.createElement("input");
  field.setAttribute("aria-hidden", "true");
  field.tabIndex = -1;
  // 16px: below that iOS zooms the page on focus
  field.style.cssText =
    "position:fixed;top:0;left:0;opacity:0;height:0;font-size:16px;pointer-events:none";
  document.body.appendChild(field);
  field.focus({ preventScroll: true });
  window.setTimeout(() => field.remove(), 1000);
};
